module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUCAIAAACMMcMmAAABBElEQVRIx2P4T3vAMGoHCvj3/+9vWtnx7/e3HxcX/by66v+/PzSw49+fn1dXf14R+Ov2dqqF1dcdBd/2VP44PR2IvmxKedfC+XG+/d8PD6kRH39+/n587N/3d+86BN42MCCjP29vUyHOfz848GV9HMjERmY0C4AIKEUFO6AWYKBPSzx/Xlvz++Hh/39+UOyPZ2cwLfg4yxQoTs38AQyuz8v9P68Mfj9R6ce5uX+en6NhHvzz6gqt8vnvv3/uvHqOVerBm1dAWer44/bLZ0Dy8bs3//79A2W+f/+AbLg41cLq4uP7lx4/ePbhLdBPQBLIBopQPz5+/P71F+wPIAlkj9YftAAAe1pvOlxaUoQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/cy.png
// module id = 264
// module chunks = 0